export default function pinnedEntityToGltf(el) {
  if (!NAF.utils.isMine(el)) return;

  // Construct a GLTF node from this entity
  const object3D = el.object3D;
  const components = el.components;
  const networkId = components.networked.data.networkId;

  const gltfComponents = {};
  // TODO: Move to MOZ_hubs_components and include version number. Requires migration of existing room objects.
  // Please do this before making a breaking change to the data stored here.
  const gltfNode = { name: networkId, extensions: { HUBS_components: gltfComponents } };

  // Adapted from three.js GLTFExporter
  const equalArray = (x, y) => x.length === y.length && x.every((v, i) => v === y[i]);
  const rotation = object3D.quaternion.toArray();
  const position = object3D.position.toArray();
  const scale = object3D.scale.toArray();

  if (!equalArray(rotation, [0, 0, 0, 1])) gltfNode.rotation = rotation;
  if (!equalArray(position, [0, 0, 0])) gltfNode.translation = position;
  if (!equalArray(scale, [1, 1, 1])) gltfNode.scale = scale;

  if (components["media-loader"]) {
    const assetSrc = components["media-loader"].data.assetSrc;
    const mediaSrc = components["media-loader"].data.src;
    const mediaVersion = components["media-loader"].data.version;
    const mediaContentSubtype = components["media-loader"].data.contentSubtype;
    const mediaHref = components["media-loader"].data.mediaOptions?.href;
    const mediaHideHref = components["media-loader"].data.mediaOptions?.hideHref;
    const mediaSmoothTransition = components["media-loader"].data.mediaOptions?.smoothTransition;

    // Prioritize assetSrc (/assets/{uuid}) over src for persistence
    const srcToPersist = assetSrc || mediaSrc;

    if (srcToPersist.startsWith("hubs://") && srcToPersist.endsWith("/video")) {
      // Do not persist hubs client video urls
      return null;
    }

    gltfComponents.media = {
      src: srcToPersist,
      version: mediaVersion,
      contentSubtype: mediaContentSubtype,
      id: networkId,
      mediaOptions: {
        href: mediaHref,
        hideHref: mediaHideHref,
        smoothTransition: mediaSmoothTransition
      }
    };

    if (assetSrc) {
      gltfComponents.media.assetSrc = assetSrc;
    }

    if (components["media-pdf"]) {
      gltfComponents.media.pageIndex = components["media-pdf"].data.index;
    }

    if (components["media-video"] && components["media-video"].data.videoPaused) {
      gltfComponents.media.paused = true;
      gltfComponents.media.time = components["media-video"].data.time;
    }
  }

  // Save the visible state of the entity
  if (components["visible"]) {
    gltfComponents.visible =
      typeof components["visible"] === "boolean" ? components["visible"] : components["visible"].data;
  }

  if (components["shadow"]) {
    gltfComponents.shadow = {
      cast: components["shadow"].data.cast,
      receive: components["shadow"].data.receive
    };
  }

  // Save body-helper data
  if (components["body-helper"]) {
    gltfComponents.bodyHelper = {
      enabled: components["body-helper"].data.enabled,
      mass: components["body-helper"].data.mass,
      gravity: components["body-helper"].data.gravity,
      linearDamping: components["body-helper"].data.linearDamping,
      angularDamping: components["body-helper"].data.angularDamping,
      linearSleepingThreshold: components["body-helper"].data.linearSleepingThreshold,
      angularSleepingThreshold: components["body-helper"].data.angularSleepingThreshold,
      angularFactor: components["body-helper"].data.angularFactor,
      type: components["body-helper"].data.type,
      activationState: components["body-helper"].data.activationState,
      collisionFilterGroup: components["body-helper"].data.collisionFilterGroup,
      collisionFilterMask: components["body-helper"].data.collisionFilterMask,
      scaleAutoUpdate: components["body-helper"].data.scaleAutoUpdate
    };
  }

  gltfComponents.pinnable = { pinned: true };

  return gltfNode;
}
